import {Button} from 'antd';
import {useState} from 'react';
import {Link} from 'react-router-dom';

import BgImg2 from '../../Assets/img7.png';
import BgImg from '../../Assets/img8.jpg';
import Logo from '../../Assets/logo.png';
import logo from '../../Assets/newlogo-removebg-preview.png';

import {LoginScreen} from './LoginScreen';

const AuthLayout = () => {

  return (
    <div style={{backgroundImage: `url(${BgImg})`}}
      className={'min-h-screen flex flex-col items-center md:p-0 p-8 bg-no-repeat bg-cover justify-center'}>
      <img
        src={Logo}
        alt={'logo'}
        className={'md:h-full h-[50px] md:w-[500px] w-[300px] mb-8 object-cover'}
      />
      <div
        className={' w-full max-w-5xl md:h-[480px] h-[600px] rounded-2xl shadow-lg flex md:flex-row flex-col justify-center items-center text-center overflow-hidden backdrop-blur-lg '}
      >
        {/* LEFT IMAGE */}

        <div className={'md:w-1/2 w-full md:ml-0 ml-20 '}>
           
          <img
            src={logo}
            alt={'IMG'}
            className={'md:h-full h-[250px] md:w-full object-cover'}
          />
        </div>
        
        {/* RIGHT FORM */}
        <div className={'w-full md:w-1/2 flex items-center justify-center px-6 backdrop-blur-md'}>
          <div className={'w-full max-w-sm'}>
           
            <h1 className={'text-gold font-bold font-serif pb-6 md:text-4xl text-2xl'}>LOGIN</h1>
            <LoginScreen />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
